// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Actions from '../../../actions'
import { colors } from '@lmc/common/constants'
import { FormInput } from '../../../LEGACY/elemental'
import Octicon, { Search } from '@githubprimer/octicons-react'
import AnimateHeight from 'react-animate-height'
import { get } from 'lodash'
import { PropertyFilterList, PropertyFilterTags } from '../../filters'
import { Button, Icon } from '@lmc/ui-kit'
export class SidebarFilter extends React.Component {
  state = {
    hasOpenList: false,
    isShowingSearch: false,
    openList: null
  }

  componentDidMount() {
    const { filterId } = this.props
    if (!filterId) return null
    this.setInitialFilters(filterId)
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.filterId && this.props.filterId) {
      this.setInitialFilters(this.props.filterId)
    }
  }

  setInitialFilters = (filterId) => {
    const { activeFilters, toggleActiveFilter, hasCarePlans } = this.props
    const key = filterId === 'residents' ? 'status' : 'active'

    if (!activeFilters || !activeFilters[key]) {
      let value = true
      if (filterId === 'residents') {
        value = hasCarePlans
          ? ['active', 'dummy', 'pre-assessment']
          : ['active', 'dummy']
      }
      toggleActiveFilter({ key, value })
    }
  }

  handleSearchChange = (e) => {
    this.props.onSearchChange(e.target.value)
  }

  handleSearchToggle = () => {
    this.setState((prevState) => ({
      isShowingSearch: !prevState.isShowingSearch
    }))
    this.props.onSearchChange('')
  }

  toggleList = (key) => {
    if (this.state.openList === key) {
      this.setState((prevState) => ({
        hasOpenList: !prevState.hasOpenList
      }))
    } else {
      this.setState({
        hasOpenList: true,
        openList: key
      })
    }
  }

  renderFilterButtons = () => {
    const { allFilters } = this.props
    const { hasOpenList, openList } = this.state
    const filterKeys = Object.keys(allFilters)

    return (
      <div style={styles.buttonsContainer}>
        {filterKeys.map((key) => {
          const filter = allFilters[key]
          const isOpen = hasOpenList && openList === key
          return (
            <div key={key}>
              <Button
                className="lmc-filter-list-button"
                onClick={() => this.toggleList(key)}
                variant="default"
                style={{ margin: 2 }}
                icon={<Icon name={isOpen ? 'UpOutlined' : 'DownOutlined'} />}
              >
                {filter.label}
              </Button>
            </div>
          )
        })}
      </div>
    )
  }

  renderLists = () => {
    const { activeFilters, allFilters, toggleActiveFilter } = this.props
    const { hasOpenList, openList } = this.state

    const filters = allFilters[openList] && allFilters[openList].filters
    const active = activeFilters && activeFilters[openList]
    return (
      <AnimateHeight
        animateOpacity
        duration={200}
        height={hasOpenList ? 'auto' : 0}
      >
        <PropertyFilterList
          active={active}
          filters={filters}
          filterKey={openList}
          onChange={toggleActiveFilter}
          style={styles.filterList}
        />
      </AnimateHeight>
    )
  }

  renderFilterTags = () => {
    const { activeFilters, allFilters, toggleActiveFilter } = this.props
    return (
      <PropertyFilterTags
        activeFilters={activeFilters}
        allFilters={allFilters}
        onChange={toggleActiveFilter}
        style={styles.paddingContainer}
      />
    )
  }

  render() {
    const { allFilters, filterId } = this.props
    const { isShowingSearch } = this.state

    if (!allFilters || !filterId) return null

    const activeStyles = isShowingSearch ? styles.activeButton : null

    return (
      <div style={styles.wrapper}>
        <div style={styles.topContainer}>
          {this.renderFilterButtons()}
          <Button
            className="lmc-sidebar-search-button"
            variant="default"
            style={{ ...styles.searchButton }}
            onClick={this.handleSearchToggle}
            icon={<Octicon icon={Search} />}
          />
        </div>
        <AnimateHeight
          animateOpacity
          duration={200}
          height={isShowingSearch ? 'auto' : 0}
        >
          <div style={styles.paddingContainer}>
            <FormInput
              autoFocus
              placeholder="Search by name"
              style={styles.search}
              onChange={this.handleSearchChange}
            />
          </div>
        </AnimateHeight>
        {this.renderLists()}
        {this.renderFilterTags()}
      </div>
    )
  }
}

const styles = {
  activeButton: {
    background: colors.grey,
    color: colors.red
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  filters: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  filterList: {
    margin: '0px 15px 15px'
  },
  search: {
    marginBottom: 15
  },
  searchButton: {
    margin: 2,
    height: 31
  },
  paddingContainer: {
    padding: '0px 15px'
  },
  topContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 15px 15px'
  },
  wrapper: {
    display: 'block',
    backgroundColor: colors.white,
    padding: '15px 0px'
  }
}

SidebarFilter.propTypes = {
  activeFilters: PropTypes.object,
  allFilters: PropTypes.object.isRequired,
  filterId: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  setSortType: PropTypes.func.isRequired,
  sortType: PropTypes.string,
  hasCarePlans: PropTypes.bool,
  toggleActiveFilter: PropTypes.func.isRequired
}

const mapStateToProps = (state, props) => ({
  activeFilters: state.global.filters[props.filterId],
  sortType: state.global.sortTypes[props.filterId],
  hasCarePlans: get(state, 'global.home.carePlans')
})

const mapDispatchToProps = (dispatch, props) => ({
  toggleActiveFilter: ({ key, value }) =>
    dispatch(
      Actions.toggleActiveFilter({
        filterId: props.filterId,
        key,
        value
      })
    ),
  setSortType: (sortType) =>
    dispatch(
      Actions.setSortType({
        key: props.filterId,
        sortType
      })
    )
})

export default connect(mapStateToProps, mapDispatchToProps)(SidebarFilter)
